var $wW, $hW;

/* ---------- CROSSBROWSER BEGIN ---------- */
var userAgent = detect.parse(navigator.userAgent),
    browserFamily = userAgent.browser.family,
    browserVersion = userAgent.browser.major;
//for Safari
if (browserFamily === 'Safari' || browserFamily === 'Mobile Safari'){
    $('html').addClass('on-safari-' + browserVersion);
}
//for IE
if (browserFamily === 'IE' || browserFamily === 'IE Mobile'){
    $('html').addClass('on-ie-' + browserVersion);
}
/* ---------- CROSSBROWSER END ---------- */

/* ---------- SERVICE FUNCTION BEGIN ---------- */
function include(url) {
    var script = document.createElement('script');
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
}
function unwrap(wrapper) {
    var docFrag = document.createDocumentFragment();
    while (wrapper.firstChild) {
        var child = wrapper.removeChild(wrapper.firstChild);
        docFrag.appendChild(child);
    }
    wrapper.parentNode.replaceChild(docFrag, wrapper);
}
function ucFirst(str) {
    if (!str) return str;
    return str[0].toUpperCase() + str.slice(1);
}
function removeChildAll(arr){
    for(var i = 0; i < arr.length; i++){
        removeChild(arr[i]);
    }
}
function removeChild(el) {
    if(el.parentNode != null) el.parentNode.removeChild(el);
}
function setAttributes(styleSet, el) {
    for(var key in styleSet) el.setAttribute(key, styleSet[key]);
}
function removeAttributes(attrRemove, el) {
    attrRemove.forEach(function(item){
        el.removeAttribute(item);
    });
}
function selected(selection, el) {
    var res = false;
    selection.map(function (item){
        if(item == el) res = true;
    });
    return res;
    /*    return selection.join().search(el) != -1 ? true : false;*/
}
function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}
/* ---------- SERVICE FUNCTION END ---------- */

/* ---------- NAVIGATION BEGIN ---------- */
function tabLink(e) {
    e.preventDefault();
    var tabContent = $(this).attr('data-link');
    $('.tabContent').addClass('hidden');
    $('#' + tabContent).removeClass('hidden');
    if ($(this).hasClass('btn-form')) {
        if ($wW < 1280) {
            Form.formShow();
            // reCaptchaInclude();
        } else {
            if($('html').hasClass('scroll')) $(document).scrollTop(0);
        }
    }
}
/* ---------- NAVIGATION END ---------- */

/* ------------- FORMS BEGIN ------------- */
var Form = {
    formClose: function (){
        $('html').removeClass('form-show').find('.form-header').removeAttr('style');
        Form.formSize();
    },
    formShow: function (){
        $('html').addClass('form-show').find('.form-header').css('display','table');
        Form.formSize();
    },
    formSize: function () {
        var hForm = $('.add-form').height() + 100;
        if($('html').hasClass('form-show')){
            $('.main-wrapper').css({'max-height': hForm }), $('body').css({'min-height': hForm});
        }else{
            $('body').removeAttr('style').find('.main-wrapper').removeAttr('style');
        }
    },
    formResize: function () {
        if($('html').hasClass('form-show')){
            $wW > 1280 ? Form.formClose() : Form.formSize();
        }
    }
}
//for PASSWORD TRIGGER
function initPassword(){
    if (!document.querySelectorAll('.password_icon').length) return;
    var passwordTrigger = document.querySelectorAll('.password_icon');
    var triggerPassword = function (e) {
        var el = e.target;
        var formGroup = el.parentNode;
        var input = formGroup.querySelector('input');
        var type = input.getAttribute('type') == "text" ? "password" : 'text';
        input.setAttribute('type', type);
        formGroup.classList.toggle('password-show');
    };
    for(var i = 0; i < passwordTrigger.length; i++){
        passwordTrigger[i].addEventListener('click', triggerPassword);
    }
}
/* ------------- FORMS END ------------- */

/* ------------- VIDEOS BEGIN ------------- */
var Videos = {
    init: function () {
        var el = $(this),
            elCurrent =  $('.stories__current .stories__item'),
            data = {
                'poster': el.attr('data-poster'),
                'src': el.attr('data-video'),
                'webm': el.attr('data-webm'),
                'flv': el.attr('data-flv'),
                'name': el.attr('data-name'),
                'residence': el.attr('data-residence'),
            },
            dataCurrent = {
                'poster': elCurrent.attr('data-poster'),
                'mp4': elCurrent.attr('data-mp4'),
                'webm': elCurrent.attr('data-webm'),
                'flv': elCurrent.attr('data-flv'),
                'name': el.attr('data-name'),
                'residence': el.attr('data-residence'),
            };

        Videos.add(elCurrent, data);
        Videos.change(el, dataCurrent);
    },
    add: function (elCurrent, data) {
        var myPlayer = afterglow.getPlayer('stories__video_current'),
            codec = {
                'mp4': 'video/mp4; codecs=&quot;avc1.42E01E, mp4a.40.2&quot;',
                'webm': 'video/webm; codecs=&quot;vp8, vorbis&quot;',
                'flv': 'video/x-flv',
            },
            source = '',
            src = [];
        Object.keys(data).forEach(function (key){
            if(data[key] != undefined){
                elCurrent.attr('data-'+ key, data[key]);
                if(key == 'mp4' || key == 'webm' || key == 'flv'){
                    var srcAssociative = {'type': 'video/'+ key, 'src': data[key]};
                    source += '<source src="'+ data[key] +'" type="'+ codec[key] +'">';
                    src.push(srcAssociative);
                }
            }
        });
        elCurrent.find('.vjs-poster').css('background-image', 'url('+ data['poster'] +')');
        elCurrent.find('#stories__video_current').attr('poster', data['poster']);
        elCurrent.find('video').attr('poster', data['poster']).html(source);
        elCurrent.find('.stories__video_name').text(data['name']);
        elCurrent.find('.stories__video_residence').text(data['residence']);
        myPlayer.src(src);
    },
    change: function (el, dataCurrent) {
        el.find('.pict_responsive_preview').css('background-image', 'url('+ dataCurrent['poster'] +')');

        Object.keys(dataCurrent).forEach(function (key){
            if(dataCurrent[key] != undefined){
                el.attr('data-'+ key, dataCurrent[key]);
            }
        });
    },
}
/* ------------- VIDEOS END ------------- */
function initResisze(){
        $wW = window.innerWidth;
        $hW = window.innerHeight;
        initResizeTabSlider();
        Form.formResize();
}
$(window).on('load resize orientationchange', function() {
    initResisze();
}).scroll(function() {
    var topScroll = $(document).scrollTop(),
        hHeader = $('.header__top').height();
    topScroll > hHeader ? $('html').addClass("scroll") : $('html').removeClass("scroll");
}).ready(function () {

    //for form password icon
    initPassword();

    //for form close
    $('.add-cancel, .form__cover').on('click', Form.formClose);

    //for tab-link
    $('.tabLink').on('click', tabLink);

    //for videos
    $('.stories__box .stories__item').on('click', Videos.init);

}).on('keydown', function(e) {
    /* ------------- KEYBOARD EVENT BEGIN ------------- */
    //for ESC - form close
    if($('html.form-show').length) {
        if(e.keyCode === 27) Form.formClose();
    }
    //for SPACEBAR - input checked
    if($('.form__group-check:focus').length){
        var check = $('.form__group-check:focus').find('input[type="checkbox"]') || $('.form__group-check:focus').find('input[type="radio"]'),
            checkState = check.prop('checked') == false ? true : false;
        if(e.keyCode === 32) check.prop('checked', checkState);
    }
    /* ------------- KEYBOARD EVENT END ------------- */
});
